// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".account-container .el-row[data-v-d0c7a258] {\n  padding-bottom: 15px;\n}\n.account-container .el-row .label[data-v-d0c7a258] {\n  color: #303133;\n  text-decoration: none;\n  font-size: 14px;\n  -webkit-font-smoothing: antialiased;\n  text-rendering: optimizeLegibility;\n  font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Arial, sans-serif;\n}", ""]);
// Exports
module.exports = exports;
